import React from "react";
import "./PageView.scss";
import MobilePage from "./MobilePage";
import WebPage from "./WebPage";
import { useLoadingImg } from "@/hooks";
import "./animation.scss";

interface IPageViewProps {}
const PageView: React.FC<IPageViewProps> = () => {
  const isMobile = window.innerWidth <= 810;
  const isLoading = useLoadingImg({ isApp: isMobile });

  if (isMobile) return <MobilePage isLoading={isLoading} />;
  return <WebPage isLoading={isLoading} />;
};

export default PageView;
